import { initializeApp } from 'firebase/app';
import {
  getFirestore,
  connectFirestoreEmulator,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  Firestore,
} from 'firebase/firestore';
import { getAuth, connectAuthEmulator, Auth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: "edye-web.firebaseapp.com",
  projectId: "edye-web",
  storageBucket: "edye-web.firebasestorage.app",
  messagingSenderId: "527717657905",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || ""
};

const app = initializeApp(firebaseConfig);

const FIRESTORE_DB = 'edye-web';

let db: Firestore;
try {
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager()
    })
  }, FIRESTORE_DB);
} catch (error) {
  console.warn('Failed to initialize Firestore with persistent cache, falling back to default:', error);
  db = getFirestore(app, FIRESTORE_DB);
}

const auth: Auth = getAuth(app);

if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATOR === 'true') {
  try {
    connectFirestoreEmulator(db, 'localhost', 8088);
  } catch (error) {
    console.warn('Firestore emulator connection skipped:', error);
  }
  try {
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  } catch (error) {
    console.warn('Auth emulator connection skipped:', error);
  }
}

export { db, auth };
